<template>
  <div class="wrapper" v-if="isGlobalDataLoaded">
    <div class="two-columns">
      <div class="column column_left">
        <Sidebar />
      </div>
      <div class="column column_right">
        <Header />
        <ProductDetails />
        <NuxtPage />
      </div>
    </div>
    <Help />
    <transition name="fade">
      <ErrorMessage />
    </transition>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '~/stores/main';

  // Components are auto-imported by Nuxt
  // Sidebar, Header, ProductDetails, Help, ErrorMessage are available globally

  const isVisible = ref(true);
  const store = useMainStore();
  const langJson = computed(() => store.langJson);
  const lang = computed(() => store.lang);
  const isGlobal = computed(() => store.isGlobal);
  const hasToken = computed(() => store.hasToken);
  const isGlobalDataLoaded = computed(() => store.isGlobalDataLoaded);

  // Set the page title from translations
  useHead(() => ({
    title: langJson.value?.[lang.value]?.seoTitle || '',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, user-scalable=no' },
      {
        hid: 'description',
        name: 'description',
        content: langJson.value?.[lang.value]?.seoDescription || ''
      },
      {
        name: 'facebook-domain-verification',
        content: langJson.value?.[lang.value]?.facebookVerificationId || ''
      }
    ],
    link: [
      // { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }
    ]
  }));

  watchEffect(() => {
    isVisible.value = !isGlobal.value || (isGlobal.value && hasToken.value && isGlobalDataLoaded.value);
  });

  // If you need to run something on mount, use onMounted from 'vue'.
  // TODO: Implement proper component mounting logic if needed
  // onMounted(() => {
  //   if (isGlobal.value && !hasToken.value) {
  //     // autoLogin();
  //   }
  // });
</script>
